<div [class.pr-small]="!paxReviewCard">
  <fcom-ufo
    [airlines]="uniqueAirlineNames"
    [departure]="(ufoAirports$ | async)?.departure"
    [arrival]="(ufoAirports$ | async)?.arrival"
    [duration]="flightOrBound.duration | finDuration | async"
    [stops]="stops"
    [showViewDetails]="!hideViewDetails"
    [tails]="tails | finTailNames"
    [isByBusOnly]="isByBusOnly"
    (viewDetails)="viewDetails.emit()"
    [focusOnViewDetails$]="viewDetailsClosed === flightOrBound.id | finToObservable"
  ></fcom-ufo>

  <div [ngClass]="{ 'card-wrapper flex flex--align-start flex--space-between': paxReviewCard }">
    <div *ngIf="paxReviewCard" class="ps-xsmall-t flex--column chip-and-price-container">
      <div class="chip-container flex flex--wrap flex--align-start">
        <fcom-chip data-test-flight-review-card-fare-family-label *ngIf="!!fareFamily">
          <span class="truncate overflow-hidden">{{ fareFamily }}</span>
        </fcom-chip>
        <fcom-chip
          *ngIf="paxReviewCard && isFlightUsingSAF"
          data-test-flight-review-card-saf-notification
          [theme]="ChipTheme.SUSTAINABILITY"
        >
          <span class="truncate overflow-hidden">{{ 'safNotification.chipText' | finLocalization }}</span>
        </fcom-chip>
      </div>
    </div>

    <fin-modify-button
      *ngIf="!hideModify"
      class="block pr-small-t"
      [label]="('actions.modify' | finLocalization) + ' ' + (title | lowercase)"
      (clicked)="modifyClicked.emit()"
    ></fin-modify-button>
  </div>
</div>
